import api from './api';

export const sendFeedback = async (feedbackData) => {
    const response = await api.post('/api/feedback', feedbackData);
    return response.data;
};
